import styled, { css } from 'styled-components';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';

export const BannerBar = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.primary};
    position: relative;
    z-index: ${theme.zIndex.navbar - 1};
    margin-top: 5rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      margin-top: 4rem;
    }
  `}
`;

export const BannerInner = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    flex-wrap: wrap;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      justify-content: center;
    }
  `}
`;

export const BannerText = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamily.display};
    font-size: ${theme.fontSize.small};
    line-height: ${theme.lineHeights.base};
    margin: 0;
    font-weight: ${theme.fontWeights.bold};

    p {
      margin: 0;
    }

    a {
      color: ${theme.colors.white};
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }

    strong {
      font-weight: ${theme.fontWeights.bold};
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      text-align: center;
      width: 100%;
    }
  `}
`;

export const BannerActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.6875rem;
    flex-shrink: 0;

    button {
      font-family: ${theme.fontFamily.display};
    }

    button:last-child {
      width: 1.5rem;
      height: 1.5rem;
      min-width: unset;
      min-height: unset;
      border-radius: 50%;
      padding: 0;
      font-size: 0.75rem;
      line-height: 1;
    }
  `}
`;
